import { FC } from 'react';
import classNames from 'classnames';

export interface FooterProps {
  className?: string;
}

export const Footer: FC<FooterProps> = ({ className, ...props }) => (
  <footer className={classNames(`bg-primary text-white py-6 md:py-10 relative`, className)} {...props} />
);
